import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    textEdit: {
        paddingBottom: "15px"
    },
    dropDown:{
        paddingTop: "15px",
        // paddingBottom: "5px"
    }
}));